import {StyleSheet, Text, TouchableOpacity, View} from "react-native";
import {ChevronLeft, ChevronRight} from "lucide-react-native";
import {Image} from "expo-image";
import React from "react";
import {useTranslation} from 'react-i18next';
import {AppDataMediaItem} from "@/data/app-data-interfaces";
import {ThemeType} from "@/theming/baseTheme";
import {useCurrentTheme} from "@/theming/useCurrentTheme";

interface VideoNavigationControlItemProps {
    video: AppDataMediaItem;
    direction: 'previous' | 'next';
    onPress: () => void;
}

export function VideoNavigationControlItem({video, direction, onPress}: VideoNavigationControlItemProps) {
    const {t} = useTranslation();
    const {theme} = useCurrentTheme();
    const styles = createStyles(theme);

    function getText() {
        return direction === 'previous' ? t('media.navigation.previous') : t('media.navigation.next');
    }

    return (
        <TouchableOpacity
            style={styles.navButton}
            onPress={onPress}
        >
            <View style={styles.navDirectionContainer}>
                {direction === 'previous' &&
                    <ChevronLeft size={16} color={theme.colors.textSecondary} strokeWidth={2}/>}
                <Text style={styles.navDirection}>{getText()}</Text>
                {direction === 'next' && <ChevronRight size={16} color={theme.colors.textSecondary} strokeWidth={2}/>}
            </View>
            <Text style={styles.navTitle} numberOfLines={1}>
                {video.name}
            </Text>
            <Image
                source={video.image.sm}
                style={styles.navThumbnail}
                placeholder={{blurhash: video.imageBlurhash}}
                contentFit="cover"
                transition={200}
            />
        </TouchableOpacity>
    );
}


const createStyles = (theme: ThemeType) => StyleSheet.create({
    navButton: {
        flex: 1,
        backgroundColor: `${theme.colors.surface}`,
        borderWidth: 1,
        borderColor: `${theme.colors.border}`,
        borderRadius: 12,
        padding: 16,
    },
    navDirectionContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 4,
        marginBottom: 4,
    },
    navDirection: {
        fontSize: 12,
        color: theme.colors.textSecondary,
        fontWeight: '600',
        textTransform: 'uppercase',
    },
    navTitle: {
        fontSize: 14,
        fontWeight: '600',
        color: theme.colors.text,
        lineHeight: 18,
    },
    navThumbnail: {
        width: '100%',
        height: 60,
        borderRadius: 8,
        marginTop: 8,
    },
});
